import { render, staticRenderFns } from "./times.vue?vue&type=template&id=6ca54f20&scoped=true&"
import script from "./times.vue?vue&type=script&lang=js&"
export * from "./times.vue?vue&type=script&lang=js&"
import style0 from "./times.vue?vue&type=style&index=0&id=6ca54f20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca54f20",
  null
  
)

export default component.exports